{
  "entitySuggestion": {
    "duplicates": {
      "heading": {
        "system": "This system may already exist",
        "orgFunction": "This Function may already exist"
      },
      "useThisInstead": {
        "system": "Use this system",
        "orgFunction": "Use this Function"
      },
      "reasons": {
        "same_category": "Same category",
        "same_department": "Same department"
      },
      "linkError": "Couldn't link the suggestion. Please try again.",
      "checking": "Checking for duplicates…"
    },
    "kind": {
      "system": "System",
      "orgFunction": "Function"
    },
    "system": {
      "dialog": {
        "title": "Suggest a system",
        "description": "An administrator will review your suggestion and add the system.",
        "name": "System name",
        "description_field": "Description",
        "category": "Category",
        "categoryHint": "What kind of system is it most likely? e.g. CRM / ERP / HCM",
        "url": "Link to the provider's website",
        "submit": "Suggest"
      },
      "card": {
        "pendingBadge": "Suggested"
      }
    },
    "orgFunction": {
      "dialog": {
        "team": {
          "title": "Suggest a Team",
          "description": "An administrator will review your suggestion and create the team.",
          "name": "Name of the team"
        },
        "role": {
          "title": "Suggest a Function",
          "description": "An administrator will review your suggestion and create the function.",
          "name": "Name of the function / role / team"
        },
        "description_field": "Description",
        "department": "Department",
        "departmentHint": "Which department is the function best located in?",
        "email": "Email",
        "submit": "Suggest"
      },
      "card": {
        "pendingBadge": "Suggested"
      }
    },
    "review": {
      "titleSystem": "Review system suggestion",
      "titleTeamSuggestion": "Review team suggestion",
      "titleFunctionSuggestion": "Review function suggestion",
      "descriptionSystem": "Add {{name}} as a new system to the catalog, or merge it with an existing system.",
      "descriptionTeamSuggestion": "Add {{name}} as a new team to the catalog, or merge it with an existing team.",
      "descriptionFunctionSuggestion": "Add {{name}} as a new function to the catalog, or merge it with an existing function.",
      "createAsNew": {
        "system": "Create as new system",
        "team": "Create as new team",
        "function": "Create as new function"
      },
      "titleApproveSystem": "Approve & create system",
      "titleApproveTeam": "Approve & create team",
      "titleApproveFunction": "Approve & create function",
      "descriptionApproveSystem": "Create {{name}} as a new system and approve the suggestion. Recordings that referenced it will link to the new system.",
      "descriptionApproveTeam": "Create {{name}} as a new team and approve the suggestion. Recordings that referenced it will link to the new team.",
      "descriptionApproveFunction": "Create {{name}} as a new function and approve the suggestion. Recordings that referenced it will link to the new function.",
      "approveAndCreate": "Approve & create",
      "proposedDetails": {
        "headingSystem": "Proposed system",
        "headingTeam": "Proposed function",
        "name": "Name",
        "kind": "Type",
        "category": "Category",
        "url": "URL",
        "description": "Description",
        "department": "Department",
        "email": "Email"
      },
      "mergeWithExistingSection": {
        "system": "Merge with an existing system instead",
        "orgFunction": "Merge with an existing Function instead"
      },
      "mergeSelectPlaceholder": {
        "system": "Choose an existing system…",
        "orgFunction": "Choose an existing Function…"
      },
      "confirmMerge": {
        "title": {
          "system": "Merge with existing system?",
          "orgFunction": "Merge with existing Function?"
        },
        "description": {
          "system": "“{{suggestionName}}” will be merged into “{{targetName}}”. The source recording will point to the existing system afterwards. This action cannot be undone.",
          "orgFunction": "“{{suggestionName}}” will be merged into “{{targetName}}”. The source recording will point to the existing Function afterwards. This action cannot be undone."
        },
        "confirm": "Merge"
      },
      "reject": "Reject",
      "approved": "Suggestion approved",
      "rejected": "Suggestion rejected",
      "merged": "Suggestion merged",
      "sourceRecording": "Suggested in",
      "submittedBy": "Submitted by",
      "submittedAt": "Submitted on",
      "confirmReject": {
        "title": "Reject suggestion?",
        "description": "The suggestion will be rejected and not added to the knowledge base. Please provide a reason."
      },
      "fields": {
        "rejectionReason": "Reason for rejection"
      },
      "placeholders": {
        "rejectionReason": "Briefly explain why this suggestion is being rejected"
      }
    }
  }
}
